@for (status of gallery.enabled_asset_statuses | assetStatusOrder; track status) {
  <app-button-menu-item
    [icon]="status | assetStatusIcon"
    [fullWidth]="true"
    name="asset-status"
    [location]="location"
    [analyticsExtra]="{ status: status }"
    [shortcut]="status | assetStatusShortcut"
    [iconColor]="status | assetStatusColor"
    [color]="status === currentStatus ? (status | assetStatusButtonColor) || 'simple' : 'simple'"
    [weight]="status === currentStatus ? 'bold' : undefined"
    (onClick)="onSelectStatus.emit(status)"
    [attr.data-test-id]="'asset-status-' + status"
  >
    {{ status | assetStatusName }}
  </app-button-menu-item>
}
